import React from 'react';
import CompetitionsBoard from '../components/Competitions/CompetitionsBoard';

/* /teacher/competitions: see the challenges and score the projects 1-10 */
const TeacherCompetitions = () => <CompetitionsBoard mode="teacher" />;

export default TeacherCompetitions;
